export default __webpack_public_path__ + "static/media/crm.d07cc181.gif";